export const STUDY_EMAIL = 'dmresearchuk@omnigenbiodata.co.uk';
export const STUDY_TEL = '07487305440';
export const ENROLMENT_URL = 'www.discovermestudy.com/dmuk/practices/';
